export enum GeocodeAccuracy {
    NotGeocoded = 0,
    NotFound = 1,
    Invalid = 2,
    Approximate = 3,
    GeometricCenter = 4,
    RangeInterpolated = 5,
    Rooftop = 6,
}

const geocodeAccuracyDescription = {
    NotGeocoded: 'Not Geocoded',
    NotFound: 'Not Found',
    Invalid: 'Invalid',
    Approximate: 'Approximate',
    GeometricCenter: 'Geometric Center',
    RangeInterpolated: 'Range Interpolated',
    Rooftop: 'Rooftop',
};

export const GeocodeAccuracyDescription = {
    ...geocodeAccuracyDescription,

    get: (value: GeocodeAccuracy | undefined | null): string | undefined => {
        if (typeof (value) === "string") {
            return geocodeAccuracyDescription[value];
        }
        if (value===null || value===undefined) {
            return undefined;
        }
        return geocodeAccuracyDescription[GeocodeAccuracy[value]  as keyof typeof geocodeAccuracyDescription];
    },
    all: [
        { value: 0, label: geocodeAccuracyDescription.NotGeocoded },
        { value: 1, label: geocodeAccuracyDescription.NotFound },
        { value: 2, label: geocodeAccuracyDescription.Invalid },
        { value: 3, label: geocodeAccuracyDescription.Approximate },
        { value: 4, label: geocodeAccuracyDescription.GeometricCenter },
        { value: 5, label: geocodeAccuracyDescription.RangeInterpolated },
        { value: 6, label: geocodeAccuracyDescription.Rooftop },
    ] as ReadonlyArray<{label: string, value: number}>
};
